export function _camelToColonSeparated(text) {
    return text.replace(/([a-z])([A-Z])/g, '$1:$2').toLowerCase();
}
class CustomEventWithoutDetail extends CustomEvent {
    static toString() {
        return _camelToColonSeparated(this.name);
    }
}
class CustomEventWithDetail extends CustomEvent {
    static toString() {
        return _camelToColonSeparated(this.name);
    }
    constructor(eventType, eventInitDict){
        super(eventType, eventInitDict);
    }
}
const DifferentUser = new CustomEventWithoutDetail('MauthDifferentUser');
const Logout = new CustomEventWithoutDetail('MauthLogout');
const UserUpdate = new CustomEventWithoutDetail('MauthUserUpdate');
export const events = {
    Logout,
    UserUpdate,
    DifferentUser
};
